<template>
  <div class="p-menu mb-16 mt-px sm:mt-0 sm:mb-0">
    <ModalError :visible="showModalError" :errorType="errorType" ></ModalError>
    <div class="menu-main-content">

      <div class="hidden sm:block mobile-view">
        <ImageScroller v-if="menuImages && menuImages.length > 1" :fullwidth="true" :images="menuImages" />
        <FluidImage v-if="menuImages && menuImages.length === 1" :src="menuImages[0].imageUrl" :alt="menuImages[0].imageExplanation" wrapper-class="mb-4" />
        <TextLineCutter v-if="menuBasicInfo && menuBasicInfo.leadCopy" :text="menuBasicInfo.leadCopy" :lines="3"  wrapper-class="font-size13" />
        <hr class="std-line-breaker" />



        <GoogleMapIframe :latitude="latitude" :longitude="longitude" :height="236" />
        <RightArrowText wrapper-class="hidden sm:flex" @click="openMap" text="Google Mapで見る" />

        <div class="main-detail-equipments" v-if="!!facilitiesMap && facilitiesMap.length > 0">
            <GrayPanel v-for="(itemFac, indexFac) in facilitiesMap" :key="indexFac" :title="itemFac.title">
                <template v-if="itemFac.isUrl">
                    <a :href="itemFac.value" target="_blank">{{itemFac.value}}</a>
                </template>
                <template v-else>{{ itemFac.value }}</template>
            </GrayPanel>
        </div>
        <hr class="std-line-breaker" />

        <EquipmentServices v-if="equipmentServiceData" :equipmentServiceData="equipmentServiceData" />

        <div class="service-section box" v-if="menuInfomation && menuInfomation.length > 0">
          <DashTitle text="インフォメーション" />
          <TextHeightCutter :height="100" wrapper-class="content">
            <ul class="plain-list-style">
              <li v-for="(menu, index) in menuInfomation" :key="`memuInfo-${index}`">
                <h5 v-show="menu.title" class="font-bold">
                  {{ menu.title }}
                </h5>
                <template v-if="menu.content">
                  <p class="mb-1" :class="{ 'view-more-open': menu.loadMore }" v-html="menu.content.replaceAll('\n', '<br/>')">
                  </p>
                </template>
                <p class="mb-3">
                  <a
                    :href="menu.linkUrl"
                    target="_blank"
                    class="blue"
                    v-if="menu && menu.linkUrl && menu.linkNm"
                  >{{ menu.linkNm }}</a>
                </p>
              </li>
            </ul>
          </TextHeightCutter>
          <hr class="std-line-breaker" />
        </div>


        <MainFooterSection :isRakuten="isRakuten" />

      </div>

      <div class="block sm:hidden c-box sm:shadow-none sm:rounded-none">
        
        <section>
          <div class="main-top">
            <div class="main-top-right">
              <div
                class="label label-grey-200"
                v-for="(tag, index) in menuIcons"
                :key="`tag-${index}`"
              >
                {{ tag.iconNm }}
              </div>
            </div>
          </div>
        </section>

        <!-- /* Carousel */ -->
        <section class="lg:pl-4">
          <div class="main-demo">
            <BasicCarousel
              class="mb-4 lg:hidden"
              :images="menuImages"
              :isShowIndicator="false"
            />
            <div class="sm:hidden menu-carousel">
              <div
                class="slide-images-mobile hidden lg:flex overflow-x-auto"
                v-if="menuImages"
              >
                <div
                  :class="menuImages.length === 1 ? 'img-slide-one' : 'img-slide'"
                  v-for="(item, index) in menuImages"
                  :key="`menuImages-${index}`"
                >
                  <img :src="`${item.imageUrl}`" :alt="`${item.imageExplanation}`" />
                </div>
              </div>
            </div>
            <div class="menu-calendar">
              <!-- Information -->
              <div class="main-information">
                <div class="sm:hidden box-content" v-if="menuBasicInfo">
                  <div>
                    {{ menuBasicInfo.catchCopy }}
                  </div>
                  <BoxViewMore2 @open="openView($event)">
                    <p
                      class=""
                      v-html="menuBasicInfo.leadCopy.replaceAll('\n', '<br>')"
                      v-show="menuBasicInfo && menuBasicInfo.leadCopy"
                      :class="viewMore ? 'three-lines-ellipsis' : 'view-more-open'"
                    ></p>
                  </BoxViewMore2>
                </div>
                <div
                  class="main-information-refer lg:flex-wrap"
                  v-if="menuHashtags && menuHashtags.length > 0"
                >
                  <div class="label label-grey-200 title-tag">
                    <span class="self-center">利用シーン</span>
                  </div>
                  <div class="content-tag">
                    <div
                      class="list-links"
                      v-for="(item, index) in menuHashtags"
                      :key="`hastag-${index}`"
                    >
                      <a
                        v-if="item.freeWord"
                        :href="hashQuery + `&keyword=${item.freeWord}`"
                      >
                        #{{ item.freeWord }}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <!-- Viewmore -->
        <section v-if="menuInfomation && Array.isArray(menuInfomation)">
          <SectionContentTitle
            :lineType="lineType.vertical"
            titleContent="インフォメーション"
          />
          <div
            class="main-description"
            v-for="(menu, index) in menuInfomation"
            :key="`memuInfo-${index}`"
          >
            <BoxView
              @open="openViewMenuInformation($event, index)"
              :minCollapse="125"
              :refName="`memuInfo-${index}`"
            >
              <h3 v-show="menu.title">
                {{ menu.title }}
              </h3>
              <template v-if="menu.content">
                <p class="mb-3" :class="{ 'view-more-open': menu.loadMore }" v-html="menu.content.replaceAll('\n', '<br/>')">
                </p>
              </template>
              <p>
                <a
                  :href="menu.linkUrl"
                  target="_blank"
                  class="blue"
                  v-if="menu && menu.linkUrl && menu.linkNm"
                  >{{ menu.linkNm }}</a
                >
              </p>
            </BoxView>
          </div>
        </section>

        <!-- Map -->
        <section>
          <div class="main-detail" ref="googleMap">
            <div class="main-detail-map mb-8">
              <iframe
                width="100%"
                style="border: 0"
                loading="lazy"
                allowfullscreen
                :src="`https://www.google.com/maps/embed/v1/place?key=${GOOGLE_MAP_KEY}&q=${latitude},${longitude}&center=${latitude + mapCenter},${longitude}`"
              >
              </iframe>

              <div class="flex justify-end mt-2">
                <a @click="openMap" target="_blank">
                  <span class="text-black">Google Mapで見る</span>
                  <i class="icon icon-bor-arrow-right text-primary pl-2" />
                </a>
              </div>
            </div>
            <!-- 周辺施設 -->
            <template v-if="infectionControl.length > 0">
              <a-card class="card my-5">
                <SectionContentTitle
                  lineType="h-line"
                  class="title-bold"
                  titleContent="感染対策について"
                />
                <div class="grid grid-cols-2 px-6">
                  <span
                    v-for="(el13, index13) in infectionControl"
                    :key="`bath-type-${index13}`"
                  >
                    <span
                      class="pr-3"
                      v-if="el13 && el13.equipServValue2 && el13.equipServValue2 == '〇'"
                    >
                      {{ el13.equipServNm2 }}
                    </span>
                  </span>
                </div>
              </a-card>
            </template>
            <div class="main-detail-equipments" v-if="!!facilitiesMap && facilitiesMap.length > 0">
              <div
                class="item-detail-label w-full"
                v-for="(itemFac, indexFac) in facilitiesMap"
                :key="indexFac"
              >
                <div class="label label-lg label-grey-200">{{ itemFac.title }}</div>
                <div class="item-detail-content">
                  <template v-if="itemFac.isUrl">
                    <a :href="itemFac.value" target="_blank">{{
                      itemFac.value
                    }}</a></template
                  >
                  <template v-else>{{ itemFac.value }}</template>
                </div>
              </div>
            </div>
          </div>
        </section>
        <EquipmentServices :equipmentServiceData="equipmentServiceData" />
        <MainFooterSection :isRakuten="isRakuten" />
      </div>

      <!-- Recommended -->
      <section class="mb-12 mt-8 p-0 sm:hidden" v-if="aroundServices && aroundServices.length">
        <SectionContentTitle
          :lineType="lineType.horizontal"
          titleContent="周辺のおすすめサービス"
        />
        <div class="list-recommended-services">
          <RecommendedItem
            v-for="(item, index) in aroundServices.slice(0, 4)"
            :key="`recommended-${index}`"
            :recommended_data="item"
          />
        </div>
      </section>

      <section
        class="mb-12 mt-8 p-0 sm:hidden"
        v-if="menuCategoryTag && sameCategoryMenus && sameCategoryMenus.length"
      >
        <SectionContentTitle
          :lineType="lineType.horizontal"
          titleContent="同じカテゴリのサービス"
        />
        <div class="list-recommended-services">
          <RecommendedItem
            v-for="(item, index) in sameCategoryMenus.slice(0, 4)"
            :key="`recommended-${index}`"
            :recommended_data="item"
          />
        </div>
      </section>

      <!-- <section class="mb-20 p-0 lg:pl-5">
        <SectionContentTitle
          :lineType="lineType.horizontal"
          titleContent="おすすめの特集・イベント"
        />
        <CarouselEvents :img="dataImg" />
      </section> -->
    </div>
  </div>
</template>

<script>
/* eslint-disable vue/no-side-effects-in-computed-properties */
import moment from 'moment'
import { get, cloneDeep, forEach } from 'lodash'
import { getCookieValue } from '@/utils/cookie'

import BoxView from './components/BoxViewMore'
import MainFooterSection from './components/MainFooterSection'
import EquipmentServices from './EquipmentServices'
import { SectionContentTitle } from '@/components/compound'
import { DashTitle, FluidImage, RightArrowText, GoogleMapIframe, GrayPanel, ImageScroller, TextLineCutter, TextHeightCutter } from '@/components/compound'
import { Calendar } from '@/components/primitive'
import RecommendedItem from './RecommendedItem'
import func_utils from '@/mixins/func_utils'

export default {
  mixins: [func_utils],
  components: {
    Calendar,
    RecommendedItem,
    SectionContentTitle,
    EquipmentServices,
    BoxView,
    FluidImage,
    RightArrowText,
    GoogleMapIframe,
    GrayPanel,
    MainFooterSection,
    ImageScroller,
    TextLineCutter,
    DashTitle,
    TextHeightCutter
  },

  data() {
    return {
      showModalError: false,
      errorType: '',
      menuInfomation: [],
      equipmentServiceData: [],
      open: false,
      menuBasicInfo: null,
      vacancyCalendar: {
        vacancyCalendars: []
      },
      menuIcons: [],
      menuImages: [],
      menuHashtags: [],
      photoGallery: null,
      plans: [],
      facilities: null,
      equipServices: [],
      serviceAreas: null,
      minPrice: 0,
      menuStatus: null,
      lineType: { horizontal: 'h-line', vertical: 'v-line' },
      dateFormat: 'YYYY/MM/DD',
      instockDayMap: {},
      fewLeftDayMap: {},
      outstockDayMap: {},
      stayDay: moment(new Date()),
      sameCategoryMenus: [],
      latitude: 0,
      longitude: 0,
      GOOGLE_MAP_KEY: 'AIzaSyDYDgespYtyMc8ELnoEnw8sWb80xxDNJHg',
      innerWidth: window.innerWidth,
      aroundServices: [],
      zipCode: '',
      paginationPlan: {
        page: 1,
        size: 10,
        totalItems: 0
      },
      planList: [],
      numPeople: 1,
      stayNights: 1,
      checkInDay: null,
      checkOutDay: moment().add(1, 'days'),
      status: null,
      dayOpens: null,
      dayFewLefts: null,
      dayCloses: null,
      viewMore: true,
      facilitiesMap: [],
      infectionControl: [],
      hashQuery: process.env.VUE_APP_BASE_URL
    }
  },

  computed: {
    currentDay() {
      return moment().format('YYYY/MM/DD')
    },

    getMenuDetailInfo() {
      return cloneDeep(get(this.$store.state, 'menu.menuDetail', null))
    },

    getSelectedDays() {
      if (this.stayDay) {
        const stayDay = this.stayDay.format(this.dateFormat)
        const selectedDays = [stayDay]
        for (let i = 1; i <= this.stayNights; i++) {
          selectedDays.push(moment(stayDay).add(i, 'days').format(this.dateFormat))
        }
        return selectedDays
      }
      return []
    },

    filterOpenDays() {
      this.instockDayMap = {}
      let vacancyCalendars =
        this.vacancyCalendar && this.vacancyCalendar.vacancyCalendars
          ? this.vacancyCalendar.vacancyCalendars
          : []
      vacancyCalendars = vacancyCalendars.filter((e) => e.stock > 4 || e.stock === 0)
      const instockDays = []
      vacancyCalendars.forEach((el) => {
        this.instockDayMap[el.stayDay] = true
        instockDays.push(el.stayDay)
      })
      return instockDays
    },

    filterFewLeftDays() {
      this.fewLeftDayMap = {}
      let vacancyCalendars =
        this.vacancyCalendar && this.vacancyCalendar.vacancyCalendars
          ? this.vacancyCalendar.vacancyCalendars
          : []
      vacancyCalendars = vacancyCalendars.filter((e) => e.stock > 0 && e.stock <= 4)
      const fewLeftDays = []
      vacancyCalendars.forEach((el) => {
        this.fewLeftDayMap[el.stayDay] = el.stock
        fewLeftDays.push(el.stayDay)
      })
      return fewLeftDays
    },

    filterCloseDays() {
      this.outstockDayMap = {}
      const lastDay = moment(this.stayDay).endOf('month').date()
      const vacancyCalendars =
        this.vacancyCalendar && this.vacancyCalendar.vacancyCalendars
          ? this.vacancyCalendar.vacancyCalendars
          : []
      const inStockDays = vacancyCalendars.map((e) => e.stayDay)
      const closeDays = []
      for (let i = 1; i <= lastDay; i++) {
        const month =
          this.stayDay.month() + 1 > 9
            ? this.stayDay.month() + 1
            : `0${this.stayDay.month() + 1}`
        const day = `${this.stayDay.year()}/${month}/${i > 9 ? i : `0${i}`}`
        if (!inStockDays.includes(day)) {
          this.outstockDayMap[day] = true
          closeDays.push(day)
        }
      }
      return closeDays
    },

    calendarDisabledPrev() {
      const now = moment(new Date())
      return this.stayDay.isSameOrBefore(now, 'month')
    },

    menuPrice() {
      const data = (this.planList || []).reduce((acc, plan) => {
        const calendar = get(plan, 'vacancyCalendar.vacancyCalendars', []).find((item) =>
          moment(item.stayDay).isSame(this.stayDay, 'day')
        )
        if (calendar) {
          return [...acc, calendar]
        }
        return acc
      }, [])

      const firstData = data[0] || {}
      // eslint-disable-next-line eqeqeq
      const hasRoomPrice = firstData?.roomPrice != null
      let minPrice = hasRoomPrice ? firstData?.roomPrice : firstData?.price || 0
      if (data.length) {
        data.forEach((item) => {
          const price = hasRoomPrice ? +item.roomPrice : +item.price
          if (minPrice >= price) minPrice = price
        })
      }

      return {
        price: minPrice,
        symbol: hasRoomPrice ? '円／室' : '円/人'
      }
    },

    menuCategoryTag() {
      let categoryTag = ''
      if (this.menuBasicInfo) {
        if (get(this.menuBasicInfo, 'categoryInfomation.catLrgClassNm')) {
          categoryTag = get(this.menuBasicInfo, 'categoryInfomation.catLrgClassNm')
        } else if (get(this.menuBasicInfo, 'categoryInfomation.catMidClassNm')) {
          categoryTag = get(this.menuBasicInfo, 'categoryInfomation.catMidClassNm')
        } else if (get(this.menuBasicInfo, 'categoryInfomation.catSmlClassNm')) {
          categoryTag = get(this.menuBasicInfo, 'categoryInfomation.catSmlClassNm')
        }
      }
      return categoryTag
    },
    hasPackingLot() {
      return this.equipmentServiceData?.some((equip) => {
        return equip.equipServDetail1?.some((detail) => {
          return detail.equipServDetail2?.some(
            (item) => item.equipServValue2 === '〇' && item.equipServCd2 === 'A100402146'
          )
        })
      })
    },
    hasTranfer() {
      return this.equipmentServiceData?.some((equip) => {
        return equip.equipServDetail1?.some((detail) => {
          return detail.equipServDetail2?.some(
            (item) => item.equipServValue2 === '〇' && item.equipServCd2 === 'A100402101'
          )
        })
      })
    },
    extSystemCd() {
      return get(this.menuBasicInfo, 'extSystemCd', null)
    },
    isRakuten() {
      return this.extSystemCd === 'RakutenT'
    },
    /**
     * @return { Number } Google Map pin position adjustment (latitude)
     * @see {@link https://developers.google.com/maps/documentation/embed/embedding-map? hl=yes}
     */
    mapCenter () {
      return this.innerWidth >= 640 ? 0.0006 : this.innerWidth > 440 ? 0.0013 : 0.0009
    },
  },


  created() {
    const bsjsessionid = getCookieValue(process.env.VUE_APP_SSO_COOKIE_NAME);
    this.status = bsjsessionid && bsjsessionid.length >= 2 ? bsjsessionid.slice(0, 2) : null;
    const { adultHeadCnt, checkInDate, stayNights } = this.$route.query
    this.numPeople = adultHeadCnt || 1
    if (checkInDate) {
      this.stayDay = moment(checkInDate)
      this.checkInDay = moment(checkInDate).clone().format('YYYY-MM-DD')
      this.checkOutDay = moment(checkInDate).add(stayNights || 1, 'days')
    }
    this.stayNights = stayNights || 1

    this.getPlanList()
    this.getVacancyCalendar()
    this.buildHashTagQuery()
  },

  async mounted() {
    await this.getEquipmentService()
    await this.getMenuStayInfo()
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
    });    
    document.body.classList.add('menu-detail-page', 'plain-layout-style');
  },

  destroyed() {
    document.body.classList.remove('menu-detail-page', 'plain-layout-style');
  },

  watch: {
    stayDay(val, old) {
      if (val && !val.isSame(old, 'month')) {
        this.$nextTick(() => {
          this.getVacancyCalendar()
        })
      }
    }
  },

  methods: {
    checkAllOutOfPlanRcDt() {
      const isAllOutOfPlanRcDt = this.planList?.every((plan) => {
        const planRcSttDt = plan.planBasicInfo?.planRcSttDt
        const planRcEndDt = plan.planBasicInfo?.planRcEndDt
        const isBefore = moment().isBefore(moment(planRcSttDt))
        const isAfter = moment().isAfter(moment(planRcEndDt))
        return isBefore || isAfter
      })
      if (isAllOutOfPlanRcDt) {
        this.showModalError = true
        this.errorType = "outOfStock"
      }
    },
    checkOutOfMenuRcDt() {
      const menuRcSttDt = this.menuBasicInfo?.menuRcSttDt
      const menuRcEndDt = this.menuBasicInfo?.menuRcEndDt
      if (!menuRcSttDt && !menuRcEndDt) return
      const isBefore = moment().isBefore(moment(menuRcSttDt))
      const isAfter = moment().isAfter(moment(menuRcEndDt))
      if (isBefore || isAfter) {
        this.showModalError = true
        this.errorType = "outOfStock"
      }
    },
    async getEquipmentService() {
      const { menuNo } = this.$route.params
      if (menuNo) {
        const response = await this.$repositories('plan')
          .getServiceDetail(menuNo)
          .then(
            (result) => {
              this.equipmentServiceData = result
              this.getInfection(result)
            },
            (error) => {
              this.$toasted.error(error?.message)
            }
          )
      }
    },
    getInfection(data) {
      data.forEach((elementParent) => {
        elementParent.equipServDetail1.forEach((element) => {
          const infectionControlCd1SetConstant = new Set([
            '20000000000',
            '20000000001',
            '20000000002',
            '20000000003',
            '20000000004',
            '20000000005',
            '20000000006',
            '20000000007',
            '20000000008',
            '20000000009'
          ])
          if (infectionControlCd1SetConstant.has(element.equipServCd1)) {
            this.infectionControl = this.infectionControl.concat(element.equipServDetail2)
            this.infectionControl = this.infectionControl.filter(
              (item) => item.equipServValue2 == '〇'
            )
          }
        })
      })
    },
    handleClickContent(item) {
      if (item?.isUrl) window.location.href = item.value
    },
    openView($event) {
      this.viewMore = $event
    },
    getMenuStayInfo() {
      const { menuNo } = this.$route.params
      this.$repositories('menu')
        .getMenuStay(menuNo)
        .then(
          (result) => {
            const data = result.data
            this.menuBasicInfo = data.menuBasicInfo
            this.checkOutOfMenuRcDt()
            this.menuInfomation = data.menuInfomation
            this.latitude = get(this.menuBasicInfo, 'areaInfomation.latitude')
            this.longitude = get(this.menuBasicInfo, 'areaInfomation.longitude')
            this.menuImages = get(this.menuBasicInfo, 'menuImages', [])
            this.facilities = get(data, 'facilities', null)
            this.menuHashtags = get(data, 'menuHashtags', [])
            this.equipServices = get(data, 'equipServices', []);
            if (this.facilities && this.facilities.zipCode) {
              this.zipCode = `${this.facilities.zipCode.substring(
                0,
                3
              )}-${this.facilities.zipCode.substring(3, 7)}`
            }
            this.getFacilities()
            this.getFacilitiesMap()
            this.getRecommendServices()
          },
          (error) => {
            if (+error.status === 404) {
              this.showModalError = true
            }
          }
        )
    },
    getFacilitiesMap() {
      const ORDER = [
        {title: '住所', cd1: 'A000001'},
        {title: 'アクセス', cd1: 'A000004'},
        {title: '駐車場', cd1: 'A000005'},
        {title: '送迎', cd1: 'A000006'},
        {title: '送迎情報備考', cd1: 'A000007'},
        {title: 'チェックイン時間', cd1: 'A000008'},
        {title: 'チェックアウト時間', cd1: 'A000009'},
        {title: 'TEL', cd1: 'A000002'},
        {title: 'URL', cd1: 'A000003', isUrl: true}
      ];
      const equipmentGeneral = this.equipmentServiceData
                                .find(el=>el.equipServTitleCd == 'A0000')?.equipServDetail1;
      this.facilitiesMap = ORDER.map(el => {
        el.value = equipmentGeneral?.find(equip => equip.equipServCd1 == el.cd1)?.equipServValue1;
        return el;
        // 値の無いものは要素から除外する
      }).filter(el => this.isTargetDisplayEl(el.value));
    },
    isTargetDisplayEl(val) {
      if (!this.isRakuten) {
        return true;
      }

      if (val === undefined || val === null) {
        return false;
      }
      return true;
    },
    getFacilities() {
      this.$repositories('menu')
        .getFacilities({
          latitude: this.latitude,
          longitude: this.longitude,
          page: 1
        })
        .then(
          (result) => {
            if (result.data && Array.isArray(result.data)) {
              this.aroundServices = result.data
            }
          },
          (error) => {
            this.$toasted.error(error?.message)
          }
        )
    },
    getRecommendServices() {
      const { catLrgClassCd, catMidClassCd, catSmlClassCd } = get(
        this.menuBasicInfo,
        'categoryInfomation',
        {}
      )
      this.$repositories('menu')
        .getSameCategoryMenus({
          catLrgClassCd,
          catMidClassCd,
          catSmlClassCd
        })
        .then((result) => {
          this.sameCategoryMenus = result?.data
        })
    },

    checkDisabledDate($event) {
      const now = moment(new Date())
      return $event.isBefore(now, 'date')
    },
    dayOpenDecorator($event) {
      const now = moment(new Date())
      const vacancyCalendars =
        this.vacancyCalendar && this.vacancyCalendar.vacancyCalendars
          ? cloneDeep(this.vacancyCalendar.vacancyCalendars)
          : []
      const instockDays = vacancyCalendars
        .filter((e) => e.stock > 4 || e.stock === 0)
        .map((el) => el.stayDay)

      if (this.status != null && this.status == "CC") {
        return !$event.isBefore(now, 'day') &&
          instockDays.includes($event.format(this.dateFormat))
          ? vacancyCalendars
              .filter((e) => e.stayDay === $event.format(this.dateFormat))
              .map((el) => el.stock)
              .toString()
          : ''
      }

      return !$event.isBefore(now, 'date') &&
        instockDays.includes($event.format(this.dateFormat))
        ? '○'
        : ''
    },
    fewLeftDecorator($event) {
      const now = moment(new Date())
      let vacancyCalendars =
        this.vacancyCalendar && this.vacancyCalendar.vacancyCalendars
          ? this.vacancyCalendar.vacancyCalendars
          : []
      vacancyCalendars = vacancyCalendars.filter(
        (e) => e.stock > 0 && e.stock <= 4 && e.stayDay === $event.format('YYYY/MM/DD')
      )
      // return !$event.isBefore(now, 'date') ? `<span class="text">${vacancyCalendars.length ? vacancyCalendars[0].stock : null}</span>` : ''
      if (this.status != null && this.status == "CC") {
        return !$event.isBefore(now, 'day')
          ? vacancyCalendars
              .filter((e) => e.stayDay === $event.format(this.dateFormat))
              .map((el) => el.stock)
              .toString()
          : ''
      }

      return !$event.isBefore(now, 'date')
        ? `<span class="text">${vacancyCalendars.length ? '△' : null}</span>`
        : ''
    },
    dayClosedDecorator($event) {
      const now = moment(new Date())
      const vacancyCalendars =
        this.vacancyCalendar && this.vacancyCalendar.vacancyCalendars
          ? this.vacancyCalendar.vacancyCalendars
          : []
      const inStockDays = vacancyCalendars.map((e) => e.stayDay)
      if (this.status != null && this.status == "CC") {
        return !$event.isBefore(now, 'day') &&
          !inStockDays.includes($event.format(this.dateFormat))
          ? '0'
          : ''
      }

      return !$event.isBefore(now, 'date') &&
        !inStockDays.includes($event.format(this.dateFormat))
        ? '×'
        : ''
    },
    dateCellExtraContent($event) {
      const today = moment()
      if (today.isSameOrBefore($event, 'day') && this.isMinPrice($event)) {
        return `<span class="font-semibold text-primary">${this.$filters.formatCurrency(
          this.isMinPrice($event)
        )}</span>`
      }
      return ''
    },
    isMinPrice(date) {
      if ((this.dayCloses || []).includes(date.format(this.dateFormat))) {
        return ''
      }
      let min = null
      let minVacancy = null
      this.planList.forEach((plan) => {
        plan.vacancyCalendar.vacancyCalendars.forEach((vacancy) => {
          if (vacancy.roomPrice !== null) {
            // giá phòng
            if (min === null || vacancy.roomPrice < min) {
              min = vacancy.roomPrice
              minVacancy = vacancy
            }
          } else {
            // giá người
            if (min === null || (vacancy.price && vacancy.price < min)) {
              min = vacancy.price
              minVacancy = vacancy
            }
          }
        })
      })
      if (minVacancy && moment(minVacancy.stayDay).isSame(date, 'day')) {
        return min || ''
      }
      return ''
    },
    scrollToMap() {
      this.$smoothScroll({
        scrollTo: this.$refs.googleMap,
        offset: -120
      })
    },
    openMap() {
      if (this.latitude && this.longitude) {
        window.open(`https://maps.google.com/?q=${this.latitude},${this.longitude}`)
      } else {
        window.open('https://maps.google.com')
      }
    },
    gotoGallery() {
      const { menuNo } = this.$route.params
      const query = this.$route.query
      this.$router.push({ path: `/menus/${menuNo}/photo-gallery`, query })
    },

    // ====== Plan Information======
    async getPlanList() {
      const { menuNo } = this.$route.params
      const queryPlanDetail = {
        adultHeadCnt: this.numPeople
      }

      if (this.stayDay) {
        queryPlanDetail.checkInDay = moment(this.stayDay).format('YYYY/MM/DD')
      }
      if (this.checkOutDay) {
        queryPlanDetail.checkOutDay = moment(this.checkOutDay).format('YYYY/MM/DD')
      }
      const planIdList = await this.$repositories('plan').searchPlan(
        this.paginationPlan.page - 1,
        this.paginationPlan.size,
        menuNo
      )

      this.planList = []
      if (!Array.isArray(planIdList.plans) && planIdList.plans?.length) return
      if (planIdList.plans?.length > 3) planIdList.plans.length = 3
      this.paginationPlan.totalItems = planIdList.totalItems
      let promises = []
      planIdList.plans.forEach((plan) => {
        promises.push(
          this.getPlanDetail(menuNo, plan.planId, plan.roomId, queryPlanDetail)
        )
      })
      if (promises.length) {
        const ress = await Promise.all(promises)
        ress.forEach((res) => {
          res.roomBasicInfo.planId = res?.planBasicInfo?.planId
          res.roomBasicInfo.menuNo = res?.planBasicInfo?.menuNo
          this.planList.push(res)
        })
        this.checkAllOutOfPlanRcDt()
      }
    },
    async getPlanDetail(menuNo, planId, roomId, queryPlanDetail) {
      const data = await this.$repositories('plan').getPlanDetail(
        menuNo,
        planId,
        roomId,
        queryPlanDetail
      )
      return data
    },

    isNewPlan(plan) {
      const planRcSttDt = get(plan, 'planBasicInfo.planRcSttDt', null)
      const today = moment()
      return !!(
        planRcSttDt &&
        moment(planRcSttDt).isValid() &&
        moment(planRcSttDt).isAfter(today.subtract(5, 'days'))
      )
    },

    breakfastFlag(plan) {
      const breakfastFlag = get(plan, 'planUsage.usageDetailStay.breakfastFlag', '')
      const dinnerFlag = get(plan, 'planUsage.usageDetailStay.dinnerFlag', '')
      if (breakfastFlag === '0' && dinnerFlag === '0') {
        return '朝食と夕食は含まれていません'
      } else if (breakfastFlag === '1' && dinnerFlag === '1') {
        return 'ディナーのみ'
      } else if (breakfastFlag === '1' && dinnerFlag === '0') {
        return '朝食のみ'
      } else if (breakfastFlag === '1' && dinnerFlag === '1') {
        return '朝食・夕食つき'
      } else {
        return false
      }
    },
    goToPlanList() {
      const { menuNo } = this.$route.params
      const { stayNights, checkInDate } = this.$route.query

      const query = {
        adultHeadCnt: this.numPeople
      }
      if (stayNights) query.stayNights = stayNights
      if (checkInDate) query.checkInDate = checkInDate

      this.$router.push({
        path: `/menus/${menuNo}/plans`,
        query
      })
    },

    // ====== Calendar ======
    async getVacancyCalendar() {
      const { menuNo } = this.$route.params
      const checkInDate = this.stayDay.clone().startOf('month').format('YYYY-MM-DD')
      const checkOutDate = this.stayDay.clone().endOf('month').format('YYYY-MM-DD')
      // this.$loading.show()
      const response = await this.$repositories('menu').getVacancyCalendar({
        checkInDate,
        checkOutDate,
        menuNo
      })
      // this.$loading.hide()
      const dateAvailable = get(response, 'dateAvailable', {})
      const dateAvailableArr = Object.entries(dateAvailable)
      if (dateAvailableArr) {
        this.dayOpens = cloneDeep(dateAvailableArr)
          .filter((day) => {
            const dayTmpOpen = day[0].split('_')
            day[0] = moment(dayTmpOpen[1]).format('YYYY/MM/DD')
            return day[1] > 4 && moment(day[0]).diff(moment(), 'day') >= 0
          })
          .map((dayOpen) => {
            return dayOpen[0]
          })
        this.dayFewLefts = cloneDeep(dateAvailableArr)
          .filter((day) => {
            const dayTmpFew = day[0].split('_')
            day[0] = moment(dayTmpFew[1]).format('YYYY/MM/DD')
            return day[1] <= 4 && day[1] > 0 && moment(day[0]).diff(moment(), 'day') >= 0
          })
          .map((dayFew) => {
            return dayFew[0]
          })
        this.dayCloses = cloneDeep(dateAvailableArr)
          .filter((day) => {
            const dayTmpClose = day[0].split('_')
            day[0] = moment(dayTmpClose[1]).format('YYYY/MM/DD')
            return day[1] == 0 && moment(day[0]).diff(moment(), 'day') >= 0
          })
          .map((dayClose) => {
            return dayClose[0]
          })
      }
      this.vacancyCalendar = {
        vacancyCalendars: []
      }
      forEach(dateAvailable, (value, key) => {
        const data = {
          stayDay: moment(key).format(this.dateFormat),
          stock: value
        }
        this.vacancyCalendar.vacancyCalendars.push(data)
      })
    },
    buildHashTagQuery() {
      const { menuNo } = this.$route.params;
      const {
        adultHeadCnt,
        exUpperGradesHeadCnt,
        exLowerGradesHeadCnt,
        youjiAHeadCnt,
        youjiBHeadCnt,
        youjiCHeadCnt,
        youjiDHeadCnt
      } = this.$route.query
      const numPeople =
        parseInt(adultHeadCnt || 0) +
        parseInt(exUpperGradesHeadCnt || 0) +
        parseInt(exLowerGradesHeadCnt || 0) +
        parseInt(youjiAHeadCnt || 0) +
        parseInt(youjiBHeadCnt || 0) +
        parseInt(youjiCHeadCnt || 0) +
        parseInt(youjiDHeadCnt || 0)

      this.hashQuery = this.hashQuery + `/search/menu?numPeople=${numPeople}&category=stay&stayNights=1&roomCnt=1`;
      // TODO 子供人数を考慮する必要がある？
      this.hashQuery = this.hashQuery + `&adultHeadCnt=${adultHeadCnt}`;
    },
    openViewMenuInformation($event, index) {
      const menuInfomation = _.cloneDeep(this.menuInfomation)
      menuInfomation.map((item, i) => {
        if (i === index && Boolean($event)) {
          item.loadMore = false
        } else if (i === index && !Boolean($event)) {
          item.loadMore = true
        }
        return item
      })
      this.menuInfomation = menuInfomation
    },
    onResize() {
      this.innerWidth = window.innerWidth
    }
  },
  beforeDestroy() { 
    window.removeEventListener('resize', this.onResize); 
  }
}
</script>

<style lang="scss" scoped>
@import './styles.scss';
::v-deep.main-description {
  .box-viewmore {
    &:not(.open) {
      .box-content {
        max-height: 128px;
      }
    }
  }
}
.main-detail-map {
  overflow: hidden;
  iframe {
    min-height: 570px;
    margin-top: -140px;
  }
}

@media only screen and (max-width: 440px) {
  .main-detail-map {
    iframe {
      min-height: 306px;
      margin-top: -70px;
    }
  }
}
</style>
